"use client";

import { useRouter } from "next/router";
import { useEffect, useRef } from "react";

function PageLoadOnlyAnchor({anchorId, offsetY = 0, timeout = 750}) {
  const router = useRouter();
  const containerRef = useRef(null);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash.replace('#', '') === anchorId && containerRef.current && router.isReady) {
      const scrollToAnchor = () => {
        const y = containerRef.current?.getBoundingClientRect().top + window.scrollY + offsetY;
        window.scrollTo({top: y, behavior: "smooth"});
      };

      // Wait for layout to stabilize (e.g. tab/toggle re-renders) before scrolling
      let debounceTimer;
      const observer = new ResizeObserver(() => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          observer.disconnect();
          clearTimeout(fallbackTimer);
          scrollToAnchor();
        }, 300);
      });
      observer.observe(document.documentElement);

      // Fallback in case layout never changes (already stable)
      const fallbackTimer = setTimeout(() => {
        observer.disconnect();
        clearTimeout(debounceTimer);
        scrollToAnchor();
      }, timeout);

      return () => {
        observer.disconnect();
        clearTimeout(debounceTimer);
        clearTimeout(fallbackTimer);
      };
    }
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.isReady]);

  return <div ref={containerRef} className="h-0" />
}

export default PageLoadOnlyAnchor;